module.exports = __webpack_public_path__ + "static/InfectedPersonsPrefecture_24.dot-76c0819595fdd854dba736a59130198e.svg";